import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { POSTBACKS_PERMISSIONS } from '@modules/postbacks/constants';

import type {
  IPostbackGetResponse,
} from '../types';
import {
  ADMIN_POSTBACKS_GET_URL,
  AFFILIATE_POSTBACKS_GET_URL,
  POSTBACKS_GET_QUERY_KEY,
} from '../constants';

export default function usePostbacksGetQuery(
  id: Ref<number>,
  affiliateId: Ref<number | undefined>,
): IContextQueryResult<
    IPostbackGetResponse
  > {
  const { fetchGet } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextQuery<IPostbackGetResponse>({
    queryKey: [POSTBACKS_GET_QUERY_KEY, id, affiliateId],
    queryFn: ({ signal }) => fetchGet<IPostbackGetResponse>(
      isAdminNamespace.value ? ADMIN_POSTBACKS_GET_URL : AFFILIATE_POSTBACKS_GET_URL,
      {
        signal,
        permission: POSTBACKS_PERMISSIONS.SHOW,
        urlParams: {
          id: affiliateId.value,
          postbackId: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
